"use client"

import { CircleStop } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleStopIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleStopIcon = component(Icon)({ as: CircleStop })
